import axios from "axios";
import Router from "@/router";
import * as utils from "@/utils";

async function checkOnServer(token) {

    let r = await axios.get(`/api/about/`, {
        headers: { Authorization: "Bearer " + token }
    });

    if (r && r.data && r.data.status == "ok") {
        return true;
    }
    return false;
}

async function setupAxios(token) {
   
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

// axios.defaults.headers.common['Authorization'] = token
export async function checkAuth(authPageToken) {
    
    return new Promise(async(resolve, reject) => {
        if (authPageToken && authPageToken !== "") {
            let ok = await checkOnServer(authPageToken);
            if (ok) {
                localStorage.setItem("token", authPageToken);
                setupAxios(authPageToken);
                Router.push({ name: "Assets" });
                resolve(true);
                return true;
            }
            resolve(false);
            return false;
        } else {
            let localToken = localStorage.getItem("token");
            if (localToken) {
              
                setupAxios(localToken);
                let ok = await checkOnServer(localToken);
                if (ok) {
                    setupAxios(localToken);
                    resolve(true);
                    return true;
                } else {
                    // remove invalid token
                    console.log("remove auth token");
                    localStorage.removeItem("token");
                    resolve(false);
                }
            }
        }
        resolve(false);
    });
}


// WEBPACK FOOTER //
// ./src/auth.js